import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let cache = null;

/** Pre-order close date from /api/drop (cached per page load). */
export const useDrop = () => {
  const [drop, setDrop] = useState(cache);
  useEffect(() => {
    if (cache) return;
    axios.get(`${API}/drop`).then((r) => { cache = r.data; setDrop(r.data); }).catch(() => {});
  }, []);
  return drop;
};

/** Ticks once a second. Returns { days, hours, minutes, seconds, total, closed }. */
export const useCountdown = (closesAt) => {
  const calc = () => {
    const total = closesAt ? new Date(closesAt).getTime() - Date.now() : 0;
    const t = Math.max(0, total);
    return { total, closed: !!closesAt && total <= 0, days: Math.floor(t / 86400000), hours: Math.floor(t / 3600000) % 24, minutes: Math.floor(t / 60000) % 60, seconds: Math.floor(t / 1000) % 60 };
  };
  const [v, setV] = useState(calc);
  useEffect(() => {
    setV(calc());
    const id = setInterval(() => setV(calc()), 1000);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [closesAt]);
  return v;
};

export const pad = (n) => String(n).padStart(2, "0");

export const closeDateLabel = (drop) => {
  if (!drop?.closes_at) return "";
  try {
    return new Date(drop.closes_at).toLocaleDateString(undefined, { day: "numeric", month: "long", year: "numeric", timeZone: drop.timezone });
  } catch {
    return new Date(drop.closes_at).toLocaleDateString(undefined, { day: "numeric", month: "long", year: "numeric" });
  }
};
